import type { IconSvgObject } from './types';

const Redo02Icon: IconSvgObject = [
  ["path", { d: "M20.999 3V9L14.999 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.0018 21C7.03127 21 3.00183 16.9706 3.00183 12C3.00183 7.02944 7.03127 3 12.0018 3C15.3331 3 18.2416 4.80989 19.7978 7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Redo02Icon;
